import React from "react";
import {
  Box,
  TextField,
  Button,
  Typography,
  Container,
  Paper,
} from "@mui/material";
import { useFormik } from "formik";
import { useCookies } from 'react-cookie';
import * as Yup from "yup";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import { login } from "../../services/request/Auth";
import { BackdropComponent } from "../../shared-components/backdrop/Backdrop";
import { ADMIN_DASHBOARD, ADMIN_LEADS, LEADS_LIST } from "../../services/constants/URIConstants";

const Login = () => {
  const navigate = useNavigate();
  const [cookies, setCookie] = useCookies(['auth_token']);
  const [open, setOpen] = React.useState(false);
  const formik = useFormik({
    initialValues: {
      email: "",
      pin: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Invalid email address")
        .required("Email is required"),
      pin: Yup.string()
        .required("PIN is required")
        .matches(/^\d{4}$/, "PIN must be 4 digits"),
    }),
    onSubmit: (values, { resetForm }) => {
      setOpen(true);        
      login(formik.values)
        .then((result) => {
          console.log("Result ", result);
          //   setReleaseTopics(releaseTopics.data);
          setOpen(false);          
          if(result.status===200 && result.data.loginSuccess){
            
            setCookie(`auth_token`, result.data.token, { path: '/' });
            toast.success("Login successful!", { position: "bottom-center" });
            navigate(ADMIN_DASHBOARD);
          }else if(result.status===403){              
            toast.error("Invlid Login", { position: "bottom-center" });
          }
        
        })
        .catch((err) => {
          setOpen(false);
          toast.error("Login Failed!", { position: "bottom-center" });
        });
      console.log("Login Data:", values);
      resetForm();
    },
  });

  return (
    <Container maxWidth="sm">
       <BackdropComponent visible={open} />
      <ToastContainer />
      <Paper elevation={3} sx={{ padding: 4, borderRadius: 3, mt: 6 }}>
        <Typography variant="h5" gutterBottom align="center">
          Login
        </Typography>
        <Box component="form" onSubmit={formik.handleSubmit}>
          <TextField
            fullWidth
            label="Email"
            name="email"
            value={formik.values.email}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            margin="normal"
            type="email"
            error={formik.touched.email && Boolean(formik.errors.email)}
            helperText={formik.touched.email && formik.errors.email}
          />
          <TextField
            fullWidth
            label="4 Digit PIN"
            name="pin"
            value={formik.values.pin}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            margin="normal"
            type="password"
            error={formik.touched.pin && Boolean(formik.errors.pin)}
            helperText={formik.touched.pin && formik.errors.pin}
            inputProps={{ maxLength: 4 }}
          />

          <Box display="flex" justifyContent="space-between" mt={3}>
            <Button
              variant="outlined"
              color="warning"
              onClick={() => formik.resetForm()}
            >
              Clear
            </Button>
            <Button variant="contained" color="primary" type="submit">
              Submit
            </Button>
          </Box>
          <Box display="flex" justifyContent="center" mt={4}>
            <Button
              variant="text"
              color="secondary"
              onClick={() => navigate("/signup")}
              sx={{
                background: "linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)",
                color: "white",
                paddingX: 3,
                paddingY: 1,
                borderRadius: 2,
                fontWeight: "bold",
                textTransform: "none",
                boxShadow: "0 3px 5px 2px rgba(33, 203, 243, .3)",
                "&:hover": {
                  background:
                    "linear-gradient(45deg, #1976D2 30%, #00ACC1 90%)",
                },
              }}
            >
              New to our website? Signup
            </Button>
          </Box>
        </Box>
      </Paper>
    </Container>
  );
};

export default Login;
